// If the course slug is not in this list, then the user will be redirected to the general trial course page
export const PERSONALIZED_COURSES: string[] = [
  'coding',
  'competition',
  'algorithms',
  'robotics',
  'hpe-hackathon-micro-course',
  'hpe-codewars-micro-course',
  'coding-project-trial-iit-guwahati-alcheringa-2023',
  'coding-project-trial-iit-guwahati-alcheringa-dsalgo-2023',
  'coding-project-trial-iit-bombay-mood-indigo-2023',
  'robotics',
  'hpe-code-battle-mentorship',
  'hpe-hackathon-mentorship',
  'hpe-codewars-2024-practice',
  'hackyoung-olympiad-2024',
  'codegenius-hackathon',
  'tls-trial-course',
  'math-trial-class',
  'app-development-trial-class',
  'data-science-trial-class',
  'roblox-trial-class',
  'ap-computer-science-a-trial-class',
  'scratch-programming-trial-class',
  'python-for-kids-trial-class',
  'web-development-trial-class',
  'game-development-trial-class',
  // 'ai-trial-class',
]

// Mapping of old trial course queries to their corresponding active trial course queries to which the user has been redirected
export const courseRedirect = {
  'coding-project-trial-iit-guwahati-alcheringa-2023': 'coding',
  'coding-project-trial-iit-guwahati-alcheringa-dsalgo-2023': 'algorithms',
  'coding-project-trial-iit-bombay-mood-indigo-2023': 'coding',
  robotics: 'coding',
  'hpe-hackathon-micro-course': 'coding',
  'hpe-codewars-micro-course': 'coding',
}

// Removed CODING_PROJECT_COURSES as it's no longer used

export const MATH_TRIAL_CLASS: string[] = ['math-trial-class']

// Maping competition slug to course slug
export const competitionCourseMapping = {
  'ioi-algorithms-preparation-guide': 'coding',
  'hpe-codewars-2024-code-battle': 'hpe-code-battle-mentorship',
  'hpe-codewars-2024-hackathon': 'hpe-hackathon-mentorship',
  'hpe-codewars-practice-arena': 'hpe-codewars-2024-practice',
  'hackyoung-olympiad-2024': 'hackyoung-olympiad-2024',
  'codegenius-hackathon': 'codegenius-hackathon',
}
